import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { CohortRouteError } from "@modules/cohorts/views";
import { cohortQueryOptions, isVisibleToViewer } from "@modules/cohorts";

// The cohort level of the frame: loads the cohort once for every page below it (the cohort page,
// later its settings), gives the breadcrumb its trail (« Cohortes > <name> »), and shows the
// not-found state inside the frame when the cohort is unknown or out of this account's scope.
export const Route = createFileRoute("/_staff-area/cohorts/$cohortId")({
  staticData: { crumb: "nav.cohorts" },
  loader: async ({ context, params }) => {
    const cohort = await context.queryClient.ensureQueryData(
      cohortQueryOptions(params.cohortId)
    );
    // An archived cohort is for the President only: anyone else is sent back to the list.
    if (!isVisibleToViewer(cohort)) throw redirect({ to: "/cohorts" });
    return { crumb: cohort.name };
  },
  errorComponent: CohortRouteError,
  component: Outlet,
});
